import "./btn.css"

import classNames from "classnames"
import React, { forwardRef } from "react"

import { BaseButtonElementProps } from "./BaseButton"
import { DropdownButton, DropdownButtonProps } from "./DropdownButton"

export type PageHeaderActionsDropdownButtonProps = Omit<
  BaseButtonElementProps,
  "kind"
> &
  DropdownButtonProps & {
    /** Whether the button needs attention. Adds warning styling and attention icon when true. */
    needsAttention?: boolean
  }

export function needsAttentionProps({
  className,
  needsAttention,
}: {
  className?: string
  needsAttention?: boolean
}) {
  return needsAttention
    ? {
        className: classNames(className, "tds-btn--attention"),
        prefix: (
          <span className="attention-icon" aria-label="Needs attention!" />
        ),
      }
    : {
        className,
      }
}

export const PageHeaderActionsDropdownButton = forwardRef<
  HTMLButtonElement,
  PageHeaderActionsDropdownButtonProps
>(
  (
    {
      className,
      needsAttention,
      ...props
    }: PageHeaderActionsDropdownButtonProps,
    ref
  ) => {
    return (
      <DropdownButton
        ref={ref}
        {...props}
        kind="secondary-page-header"
        {...needsAttentionProps({ className, needsAttention })}
      />
    )
  }
)

PageHeaderActionsDropdownButton.displayName = "PageHeaderActionsDropdownButton"
